import React, { useMemo } from 'react';
import { Box, ButtonBase, Typography } from "@mui/material";
import { ArrowBackIosNew } from "@mui/icons-material";
import { useNavigate } from "react-router-dom";

const _ep_TEXT_TITLE_MORE = ({ texts }) => {
    const navigate = useNavigate();

    const { titleItem, moreItem } = useMemo(() => {
        if (!texts || !Array.isArray(texts) || texts.length === 0) {
            return { titleItem: null, moreItem: null };
        }

        const sorted = [...texts].sort((a, b) => (a.Priority || 0) - (b.Priority || 0));

        // عنصری که Url دارد دکمه مشاهده بیشتر است؛ در غیر اینصورت آیتم دوم
        const more = sorted.find(t => t.Url) || (sorted.length > 1 ? sorted[1] : null);
        // عنوان بخش آیتم بدون Url یا آیتم اول است
        const title = sorted.find(t => t !== more) || sorted[0];

        return { titleItem: title, moreItem: more };
    }, [texts]);

    if (!titleItem && !moreItem) return null;

    const handleActionClick = (url) => {
        if (!url) return;
        if (url.startsWith("http://") || url.startsWith("https://")) {
            window.open(url, "_blank");
        } else {
            navigate(url);
        }
    };

    return (
        <Box
            sx={{
                display: "flex",
                alignItems: "center",
                justifyContent: "space-between",
                mx: { xs: 2, sm: 2.5 },
                mt: 3.5,
                mb: 1.5
            }}
        >
            {/* عنوان بخش همراه با نوار تاکیدی گرادیان */}
            {titleItem && (
                <Box sx={{ display: "flex", alignItems: "center", gap: 1.25 }}>
                    <Box
                        sx={{
                            width: 4,
                            height: 20,
                            borderRadius: "4px",
                            background: "linear-gradient(180deg, #e7333e 0%, #b22831 100%)",
                            boxShadow: "0 2px 8px rgba(231, 51, 62, 0.4)",
                            flexShrink: 0
                        }}
                    />
                    <Typography
                        variant="h6"
                        component="h2"
                        sx={{
                            fontWeight: 800,
                            fontSize: { xs: "1.05rem", sm: "1.15rem" },
                            color: "text.primary",
                            letterSpacing: "-0.2px",
                            lineHeight: 1.3
                        }}
                    >
                        {titleItem.Title}
                    </Typography>
                </Box>
            )}

            {/* دکمه تعاملی مشاهده همه با آیکون فلش قرمز و متن مشکی بدون پس‌زمینه */}
            {moreItem && (
                <ButtonBase
                    onClick={() => handleActionClick(moreItem.Url)}
                    sx={{
                        display: "inline-flex",
                        alignItems: "center",
                        gap: 0.6,
                        p: 0,
                        bgcolor: "transparent",
                        borderRadius: "8px",
                        cursor: "pointer",
                        transition: "all 0.2s ease",
                        "&:hover .more-title": {
                            color: "primary.main"
                        },
                        "&:hover .more-arrow": {
                            transform: "translateX(-4px)"
                        },
                        "&:active": {
                            transform: "scale(0.96)"
                        }
                    }}
                >
                    <Typography
                        className="more-title"
                        sx={{
                            fontWeight: 700,
                            fontSize: "0.85rem",
                            color: "text.primary",
                            transition: "color 0.2s ease"
                        }}
                    >
                        {moreItem.Title || "بیشتر ..."}
                    </Typography>
                    <ArrowBackIosNew
                        className="more-arrow"
                        sx={{
                            fontSize: "0.82rem",
                            color: "#e7333e",
                            fontWeight: 900,
                            stroke: "#e7333e",
                            strokeWidth: 1.2,
                            transition: "transform 0.2s ease"
                        }}
                    />
                </ButtonBase>
            )}
        </Box>
    );
};

export default React.memo(_ep_TEXT_TITLE_MORE);

